import { useState, useEffect } from 'react';
import css from './CustomerOverview.module.css';

import * as customerServices from '../../../../services/customerServices';
import Table from '../../_common/data/Table';
import AddCustomer from './AddCustomer';
import Overlay from '../../_common/elements/Overlay';
import CustomerTable from './CustomerTable';

function CustomerOverview() {
    const [customers, setCustomer] = useState([]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        let page;
        customerServices
            .getAll(page || 1)
            .then((result) => {
                setCustomer(result.data.sort((a, b) => b.customerId - a.customerId) || []);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const onAdd = (newData, newCustomerId) => {
        // e.preventDefault();

        // customerServices
        //     .create(newData)
        //     .then((res) => {
            //     })
            //     .catch((err) => {
                //         console.log(err);
                //     });
                        let updatedData = { ...newData, customerId: newCustomerId };
                        setCustomer((state) => [updatedData, ...state]);
                    handleShowModal();
    };

    const handleShowModal = (e) => {
        // if triggered from a button inside a form, e.stopPropagation() can help
        setShowModal((st) => !st);
    };

    return (
        <div className={css.main}>
            <div>
                <CustomerTable data={customers} onAdd={onAdd} service={customerServices} showModal={handleShowModal} />
                {showModal && (
                    <Overlay>
                        <AddCustomer onAdd={onAdd} onClose={handleShowModal} />
                    </Overlay>
                )}
            </div>
        </div>
    );
}

export default CustomerOverview;
